import { Component as ComponentContainer } from '@styles/layout';
import { InformationComponent } from '@model/content';
import { ContactFormGroup } from '@components/help';

export const OnlineEnquiryContainer = (props: InformationComponent) => {
  return (
    <ComponentContainer>
      <ContactFormGroup {...props} />
    </ComponentContainer>
  );
};
